import * as React from "react"
import './index.scss'
import FloatingAreaButton from "../floating_area_button"
import companies_area from '../../images/area_buttons/companies_small.svg'
import education_area from '../../images/area_buttons/school_small.svg'
import social_area from '../../images/area_buttons/social_small.svg'
const FloatingButtons = () => {
  return <div className="FloatingButtons">
    {/*       
            <FloatingAreaButton
              image={companies_area}
              to="/aziende"
              alt="Sezione aziende"
            />
            <FloatingAreaButton
              image={education_area}
              to="/scuole"
              alt="Sezione educazione"
            />
            <FloatingAreaButton
              image={social_area}
              to="/sociale"
              alt="Sezione sociale"
            /> */}
  </div>
}

export default FloatingButtons